import { useCallback, useContext } from 'react';

import {
  ErrorFromBack,
  getUniqueBuiltErrorNotifications,
  MessageDescriptorMap,
} from '../../../../helpers/errorsMessage';
import { isNetworkErrorWhileOffline } from '../helpers/isNetworkErrorWhileOffline';
import ToastsServiceContext from '../ToastsProvider.context';

export type UsePushErrorsReturnType = (
  errors: (Error | ErrorFromBack)[],
) => void;

interface UsePushErrorsArgs {
  extendedMessages?: MessageDescriptorMap;
}

const usePushErrors = ({ extendedMessages }: UsePushErrorsArgs = {}) => {
  const { pushNotifications } = useContext(ToastsServiceContext);

  return useCallback(
    (errors: (Error | ErrorFromBack)[]) => {
      const filteredErrors = errors.filter(
        (error) => !isNetworkErrorWhileOffline(error),
      );

      const toasts = getUniqueBuiltErrorNotifications({
        errors: filteredErrors,
        extendedMessages,
      });

      return pushNotifications(toasts);
    },
    [extendedMessages, pushNotifications],
  );
};

export default usePushErrors;
